<template>
    <div class="main">
        <c-panel title="CONSÓRCIOS DE MUNICÍPIOS" titleIcon="fas fa-handshake">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="O consórcio mantém catálogos padronizados que os municípios associados consomem."
                description="Cada município continua dono da sua base. O que trafega é a configuração — tipos de cargo e tipos de avaliação —, nunca dado de aluno."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="14">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar consórcio..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="10" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/consorcio/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO CONSÓRCIO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Consórcio</th>
                            <th style="width: 130px;">UF / CNPJ</th>
                            <th style="width: 130px;" class="u-text-center">Papel</th>
                            <th style="width: 110px;" class="u-text-center">Municípios</th>
                            <th style="width: 110px;" class="u-text-center">Itens</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 200px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="c in items" :key="c.id">
                            <td>
                                {{ c.nome }}
                                <div v-if="c.url_catalogo"><small class="u-text-muted">{{ c.url_catalogo }}</small></div>
                            </td>
                            <td>
                                {{ c.uf || '—' }}
                                <div v-if="c.cnpj"><small class="u-text-muted">{{ c.cnpj }}</small></div>
                            </td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="c.municipio_gestor ? 'success' : 'info'">
                                    {{ c.municipio_gestor ? 'Gestor' : 'Associado' }}
                                </el-tag>
                            </td>
                            <td class="u-text-center">{{ c.qtd_municipios }}</td>
                            <td class="u-text-center">{{ c.qtd_itens }}</td>
                            <td class="u-text-center">{{ c.situacao ? 'Ativo' : 'Inativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/consorcio/catalogo?consorcio=' + c.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button size="mini" plain title="Catálogo" icon="el-icon-notebook-2"></el-button>
                                </router-link>
                                <router-link :to="'/admin/consorcio/municipios?consorcio=' + c.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button size="mini" plain title="Municípios" icon="el-icon-office-building"></el-button>
                                </router-link>
                                <router-link v-if="podeEscrever" :to="'/admin/consorcio/edit/' + c.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(c.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="7" class="u-text-center">Nenhum consórcio cadastrado.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO M — itens 123 e 124. Interface para `api/consorcio`. */
export default {
    data: () => ({ statusList: false, filtro: { nome: '' }, items: [] }),
    computed: {
        /** Consórcio é configuração de infraestrutura — só NTI. */
        podeEscrever () { return [4, 5].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consorcio/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        excluir (id) {
            this.$confirm('Excluir este consórcio?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/consorcio/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Consórcio excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
